const tabs = [
    {
        id: 1,
        label: 'tabs.header.tab1',
        innerTabs: [
            {
                id: 111,
                label: 'tabs.tab1.tab1.header',
                content: [
                    {
                        id: 11,
                        img: '11',
                        text: 'tabs.tab1.tab1.text1',
                    },
                    {
                        id: 12,
                        img: '12',
                        text: 'tabs.tab1.tab1.text2',
                    },
                    {
                        id: 13,
                        img: '13',
                        text: 'tabs.tab1.tab1.text3',
                    },
                ],
            },
            {
                id: 112,
                label: 'tabs.tab1.tab2.header',
                content: [
                    {
                        id: 121,
                        img: '14',
                        text: 'tabs.tab1.tab2.text1',
                    },
                    {
                        id: 122,
                        img: '15',
                        text: 'tabs.tab1.tab2.text2',
                    },
                    {
                        id: 123,
                        img: '16',
                        text: 'tabs.tab1.tab2.text3',
                    },
                    {
                        id: 765,
                        img: '17',
                        text: 'tabs.tab1.tab2.text4',
                    },
                ],
            },
        ],
    },
    {
        id: 2,
        label: 'tabs.header.tab2',
        innerTabs: [
            {
                id: 21,
                label: 'tabs.tab2.tab1.header',
                content: [
                    {
                        id: 211,
                        img: '21',
                        text: 'tabs.tab2.tab1.text1',
                    },
                    {
                        id: 212,
                        img: '22',
                        text: 'tabs.tab2.tab1.text2',
                    },
                    {
                        id: 213,
                        img: '23',
                        text: 'tabs.tab2.tab1.text3',
                    },
                    {
                        id: 214,
                        img: '24',
                        text: 'tabs.tab2.tab1.text4',
                    },
                    {
                        id: 215,
                        img: '25',
                        text: 'tabs.tab2.tab1.text5',
                    },
                    {
                        id: 216,
                        img: '26',
                        text: 'tabs.tab2.tab1.text6',
                    },
                    {
                        id: 217,
                        img: '27',
                        text: 'tabs.tab2.tab1.text7',
                    },
                ],
            },
            {
                id: 22,
                label: 'tabs.tab2.tab2.header',
                content: [
                    {
                        id: 221,
                        img: '28',
                        text: 'tabs.tab2.tab2.text1',
                    },
                    {
                        id: 222,
                        img: '29',
                        text: 'tabs.tab2.tab2.text2',
                    },
                    {
                        id: 223,
                        img: '210',
                        text: 'tabs.tab2.tab2.text3',
                    },
                    {
                        id: 224,
                        img: '211',
                        text: 'tabs.tab2.tab2.text4',
                    },
                    {
                        id: 225,
                        img: '212',
                        text: 'tabs.tab2.tab2.text5',
                    },
                    {
                        id: 226,
                        img: '213',
                        text: 'tabs.tab2.tab2.text6',
                    },
                    {
                        id: 227,
                        img: '214',
                        text: 'tabs.tab2.tab2.text7',
                    },
                ],
            },
        ],
    },
    {
        id: 3,
        label: 'tabs.header.tab3',
        content: [
            {
                id: 31,
                img: '31',
                text: 'tabs.tab3.text1',
            },
            {
                id: 32,
                img: '32',
                text: 'tabs.tab3.text2',
            },
            {
                id: 33,
                img: '33',
                text: 'tabs.tab3.text3',
            },
            {
                id: 34,
                img: '34',
                text: 'tabs.tab3.text4',
            },
            {
                id: 35,
                img: '35',
                text: 'tabs.tab3.text5',
            },
            {
                id: 36,
                img: '36',
                text: 'tabs.tab3.text6',
            },
        ],
    },
    {
        id: 4,
        label: 'tabs.header.tab4',
        content: [
            {
                id: 41,
                img: '41',
                text: 'tabs.tab4.text1',
            },
            {
                id: 42,
                img: '42',
                text: 'tabs.tab4.text2',
            },
            {
                id: 43,
                img: '43',
                text: 'tabs.tab4.text3',
            },
            {
                id: 44,
                img: '44',
                text: 'tabs.tab4.text4',
            },
            {
                id: 45,
                img: '45',
                text: 'tabs.tab4.text5',
            },
        ]
    }
]

export default tabs;